/*
Internal errors
 */
const AUTH_MISSING_TOKEN = 0;
const AUTH_PERMISSION_DENIED = 1;
module.exports.AUTH_ERRORS = {
  AUTH_MISSING_TOKEN,
  AUTH_PERMISSION_DENIED
};
module.exports.AuthError = class AuthError extends Error {
  constructor(id
  /*: number*/
  ) {
    super('Authentication Error');
    this.name = 'AuthError';
    this.messageId = id;
  }

};
/**
 * A thin wrapper for ApiErrors
 */

/*
{ message: 'Required query-Parameter "fields" missing.',
  messageId: 99002 }

{ message: 'Field "domain" on property must be unique.',
  messageId: '02-67-001' }
 */

module.exports.ApiError = class ApiError extends Error {
  constructor(response
  /*: Response*/
  , jsonBody
  /*: Object*/
  ) {
    super(jsonBody ? jsonBody.message : 'Unknown API Error');
    this.name = 'ApiError';
    this.message = jsonBody.message;
    this.messageId = jsonBody.messageId;
    this.context = jsonBody;
    this.status = response.status;
    this.response = response;
  }

};
module.exports.NetworkError = class NetworkError extends Error {
  constructor(error
  /*: Error*/
  ) {
    super(error ? error.message : 'Unknown Network Error');
    this.cause = error;
    this.isNetworkError = true; // instanceof is useless garbage
  }

};